export const BALANCE_TRANSFERS_EVENTS = {
  BALANCE_PAGE: {
    VIEW_BALANCE_PAGE: 'Balance Overview Page Viewed',
    CURRENCY_TAB_SWITCHED: 'Balance Page Currency Tab Switched',
    CURRENCY_DROPDOWN_OPENED: 'Balance Page Currency Dropdown Opened',
    ACCOUNT_SELECTED: 'Balance Page Account Selected',
    BAR_SEGMENT_HOVERED: 'Balance Bar Segment Hovered',
    SETTLE_NOW_CLICKED: 'Balance Page Settle Now Clicked',
    SETTLE_NOW_POPUP_CONFIRMED: 'Balance Page Settle Now Popup Confirmed',
    CHANGE_SETTLEMENT_TYPE_TO_PENDING:
      'Instant Settlement_Alternative Payments',
    TRANSFER_REPORTS_DOWNLOADED: 'Balance Page Transfer Reports Downloaded',
    TRANSFER_REPORTS_VIEW_ALL_CLICKED:
      'Balance Page Transfer Reports View All Clicked',
    TRANSFER_DETAIL_OPENED: 'Balance Page Transfer Detail Opened',
    VIEW_ALL_TRANSFERS_CLICKED: 'Balance Page View All Transfers Clicked',
  },
  TRANSFERS_PAGE: {
    VIEW_TRANSFERS_TABLE: 'Transfers Table Page Viewed',
    TRANSFER_DETAIL_OPENED: 'Transfer Detail Opened',
    TRANSFER_QUICK_VIEW_OPENED: 'Transfer Quick View Opened',
    TRANSFER_PROOF_DOWNLOADED: 'Transfer Table Proof Downloaded',
  },
  TRANSFER_DETAIL_PAGE: {
    VIEW_TRANSFER_DETAIL_PAGE: 'Transfer Detail Page Viewed',
    TIMELINE_STEP_VIEWED: 'Transfer Timeline Step Viewed',
    PROOF_DOWNLOADED: 'Transfer Details Proof Downloaded',
    TRANSACTIONS_CSV_DOWNLOADED: 'Transfer Details Transactions CSV Downloaded',
    TRANSACTIONS_PDF_DOWNLOADED: 'Transfer Transactions PDF Downloaded',
    VIEW_RELATED_TRANSACTIONS_CLICKED:
      'Transfer Details View Related Transactions Clicked',
    TRANSFER_ID_COPIED: 'Transfer Page ID Copied',
    SETTLEMENT_ID_COPIED: 'Transfer Settlement ID Copied',
    BREAKDOWN_VIEW_TOGGLED: 'Transfer Breakdown View Toggled',
    BREAKDOWN_EXPANDED: 'Transfer Breakdown Expanded',
    SETTLE_IN_BANK_EXPANDED: 'Transfer Settle In Bank Expanded',
    FAILED_DETAIL_VIEWED: 'Transfer Failed Detail Viewed',
  },
};

export const BALANCE_TRANSFERS_EVENTS_PROPERTIES = {
  SHARED: {
    TRANSFER_ID: 'transfer_id',
    STATUS: 'status',
    AMOUNT: 'amount',
    NET_AMOUNT: 'net_amount',
    CURRENCY: 'currency',
    ACCOUNT_ID: 'account_id',
    SETTLEMENT_ID: 'settlement_id',
    ENTRY_POINT: 'entry_point',
    TIMELINE_TYPE: 'timeline_type',
    SELECTED_CURRENCY: 'selected_currency',
    PENDING_AMOUNT: 'pending_amount',
  },
  BALANCE_PAGE: {
    DEFAULT_CURRENCY: 'default_currency',
    ON_ITS_WAY_AMOUNT: 'on_its_way_amount',
    AVAILABLE_AMOUNT: 'available_amount',
    TOTAL_AMOUNT: 'total_amount',
    FROM_CURRENCY: 'from_currency',
    TO_CURRENCY: 'to_currency',
    ACTION_TAKEN_BEFORE_SWITCH: 'action_taken_before_switch',
    TIME_SPENT_ON_CURRENCY_MINUTES: 'time_spent_on_currency_minutes',
    SWITCH_COUNT_IN_SESSION: 'switch_count_in_session',
    BANK_ACCOUNT_COUNT: 'bank_account_count',
    SELECTED_BANK_ACCOUNT: 'selected_bank_account',
    SEGMENT: 'segment',
    SEGMENT_AMOUNT: 'segment_amount',
    UPCOMING_SETTLEMENT_AMOUNT: 'upcoming_settlement_amount',
    REPORT_ID: 'report_id',
    REPORT_DATE_RANGE: 'report_date_range',
    REPORT_TYPE: 'report_type',
    PANEL_REPORTS_SHOWN: 'panel_reports_shown',
  },
  TRANSFERS_TABLE: {
    TRANSFER_COUNT_VISIBLE: 'transfer_count_visible',
    ROW_POSITION: 'row_position',
    RECENT_TRANSFER_COUNT: 'recent_transfer_count',
  },
  TRANSFER_DETAIL_PAGE: {
    SETTLEMENT_TYPE: 'settlement_type',
    TIMELINE_STEPS: 'timeline_steps',
    CURRENT_STEP: 'current_step',
    COMPLETED_STEPS: 'completed_steps',
    HAS_FAILED_STEP: 'has_failed_step',
    TRANSACTION_COUNT: 'transaction_count',
    FROM_VIEW: 'from_view',
    TO_VIEW: 'to_view',
    IS_EXPANDED: 'is_expanded',
    SETTLE_AMOUNT: 'settle_amount',
    BANK_DESTINATION: 'bank_destination',
    SELECTED_VIEW: 'selected_view',
  },
};

export const BALANCE_TRANSFERS_EVENTS_VALUES = {
  XLSX: 'xlsx',
  TRANSFERS_TABLE: 'transfers_table',
  BALANCE_RECENT_TRANSFERS: 'recent_transfers',
  DETAILS: 'details',
  QUICK_VIEW: 'quick_view',
};
